import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheNavbar = _resolveComponent("TheNavbar")!
  const _component_Discover = _resolveComponent("Discover")!
  const _component_Random = _resolveComponent("Random")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheNavbar, {
      navigation: [
      {
        name: 'Discover',
        href: '/#',
        current: _ctx.isPathActive('/'),
      },
      {
        name: 'Random',
        href: '/#random',
        current: _ctx.isPathActive('/random'),
      },
      {
        name: 'GitHub',
        href: 'https://gh.godi.se/image-gallery',
        current: false,
      },
    ],
      onNavigate: _cache[0] || (_cache[0] = ($event: any) => (_ctx.path = $event))
    }, null, 8, ["navigation"]),
    _createElementVNode("div", null, [
      _withDirectives(_createVNode(_component_Discover, { categories: _ctx.categories }, null, 8, ["categories"]), [
        [_vShow, _ctx.isPathActive('/')]
      ]),
      _withDirectives(_createVNode(_component_Random, { categories: _ctx.categories }, null, 8, ["categories"]), [
        [_vShow, _ctx.isPathActive('/random')]
      ])
    ]),
    _createVNode(_component_TheFooter)
  ], 64))
}